'use strict';

import angular from 'angular';
import OauthLoginController from './oauthlogin.controller.js';

export default angular.module('georgeApp.oauthlogin', [])
  .controller('OauthLoginController', OauthLoginController)
  .name;
